import { IconActionProfile24, IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ImageNone.css';

type TImageNoneProps = {
  type: 'offer' | 'agent';
};

export const ImageNone: React.FC<TImageNoneProps> = ({ type }) => (
  <div className={styles['container']}>
    <span className={styles['icon']}>
      {type === 'offer' ? (
        <IconPlaceholderImages24 color="current_color" />
      ) : (
        <IconActionProfile24 color="current_color" />
      )}
    </span>
  </div>
);
